<template>
  <div class="formulario-modelo">
    <header class="superior">
      <div class="botones" v-if="!modoIndicadores && !modoCalificar && !modoEvidencias && store.tienePermiso('modelos.crear')">
        <router-link :to="{ name: 'CrearModelo' }">
          <button class="btn guardar">Crear Nuevo Modelo</button>
        </router-link>
      </div>
    </header>
    <!-- Pasamos ambas props -->
    <ListaModelos
      :modo-indicadores="modoIndicadores"
      :modo-calificar="modoCalificar"
      :modo-asignar-evaluadores="modoAsignarEvaluadores"
      :modo-evaluacion-expertos="modoEvaluacionExpertos"
      :modo-evidencias="modoEvidencias"
    />
  </div>
</template>

<script lang="ts" setup>
/**
 * Versiones de un modelo y carga de evidencias.
 *
 * Versionar copia los INDICADORES, no la estructura: el árbol pertenece al
 * modelo y lo comparten todas sus versiones.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/evidencias` (SubirEvidencias) — permiso `evidencias.subir`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import ListaModelos from '../components/ListaModelos.vue'
import useAutenticar from '@/store/IngresoAutenticar'

const route = useRoute()
const store = useAutenticar()

const modoIndicadores = computed(() => route.query.modo === 'indicadores')
const modoCalificar = computed(() => route.query.modo === 'calificar instrumento')
const modoAsignarEvaluadores = computed(() => route.query.modo === 'asignar-evaluadores')
const modoEvaluacionExpertos = computed(() => route.query.modo === 'evaluacion-expertos')
const modoEvidencias = computed(() => route.query.modo === 'evidencias' || route.name === 'SubirEvidencias')
</script>

<style scoped>
.formulario-modelo {
  background-color: white;
  padding: 2rem;
  border-radius: var(--radius-lg);
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  box-shadow: var(--shadow-md);
  box-sizing: border-box;
  margin: 20px;
  font-family: var(--font-family);
  min-width: 500px;
}

.superior {
  padding: 0 2rem 40px;
}

.botones {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn {
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
  flex-shrink: 0; 
}

.btn.guardar {
    background-color: #eea222;
    color: black;
}

.btn.guardar:hover {
    background-color: #0e69a0;
    cursor: pointer;
    color: white;
}

input:focus, select:focus, textarea:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
}
</style>